import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/financeiro/agencias/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findAgencia(
  empresa_cnpj,
  usuario_id,
  include,
  where = false
) {
  let query = "";
  if (where && typeof where === "object") {
    Object.keys(where).forEach((value, index) => {
      query += `&where[${value}]=${where[value]}`;
    });
  }
  return search(
    `${path}/usuario/${usuario_id}?empresa_cnpj=${empresa_cnpj}${query}${
      include ? `&include=${include}` : ""
    }`,
    "GET",
    headers
  );
}

export const findBankAccounts = async ({ empresa_cnpj, usuario_id, include }) =>
  search(
    `${path}/usuario/${usuario_id}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }`,
    "GET",
    headers
  );
